import {GetterTree} from 'vuex'
import {WidgetState} from "@/apps/MyStudyChoiceActivitiesWidget/models/store-viewmodel"
import {Config} from "@/apps/MyStudyChoiceActivitiesWidget/models/config-viewmodel";
import {IActivities, IActivity} from "@/apps/MyStudyChoiceActivitiesWidget/models/activities-viewmodel"
import {sortActivityByDate} from '@/apps/MyStudyChoiceActivitiesWidget/mixins/ActivityMixins'

export default <GetterTree<WidgetState, WidgetState>>{
    loading(state): boolean {
        return state.loading
    },
    getConfig(state): Config {
        return state.config
    },
    activitiesRetrieved(state): boolean {
        return state.activities_retrieved
    },
    availableActivities(state): IActivities {
        let today = new Date()
        let availableActivities = state.activities.filter((activity: IActivity) => {
            return activity.dateAfterUserCannotRegisterAnymore ? new Date(activity.dateAfterUserCannotRegisterAnymore).getTime() >= today.getTime() : false
        })
        availableActivities = availableActivities.filter((activity: IActivity) => {
            return activity.alwaysShowEventRegistration ? activity.alwaysShowEventRegistration : !activity.didRegister
        })
        return sortActivityByDate(availableActivities)
    },
    subscribedActivities(state): IActivities {
        let today = new Date()
        let availableActivities = state.activities.filter((activity: IActivity) => {
            return !activity.alwaysShowEventRegistration
        })
        let subscribedActivities = availableActivities.filter((activity: IActivity) => {
            return activity.didRegister
            && activity.eventArchiveDate ? new Date(activity.eventArchiveDate).getTime() >= today.getTime() : false
        })
        return sortActivityByDate(subscribedActivities)
    },
    attendedActivities(state): IActivities {
        let today = new Date()
        let activities = state.activities.filter((activity: IActivity) => {
            return activity.didRegister
            && activity.eventArchiveDate ? new Date(activity.eventArchiveDate).getTime() <= today.getTime() : false
        })
        return sortActivityByDate(activities)
    }
}
